import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { DependencyProvider } from 'gw-portals-dependency-react';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { isCapabilityEnabled } from 'gw-portals-config-js';
import { DocumentsPage } from 'gw-capability-document-react';
import {SubmissionService, JobService, PolicyService} from 'gw-capability-gateway';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { PageHeaderComponent } from '../Components/FormattedHeaderComponent/FormattedHeaderComponent';
import CommonRoutes from '../Common/CommonRouting';
import metadata from './QuoteDetails.metadata.json5';
import pageRouting from '../Common/QuoteDetails-config.json5';
import {Loader} from "@jutro/components";

const { capabilitiesConfig } = appConfig;

const DocumentPageService = {
    getDocuments: SubmissionService.getDocumentsForSubmission,
    generateUploadToken: GatewayDocumentService.generateUploadToken,
    uploadDocument: GatewayDocumentService.uploadDocument,
    removeDocument: GatewayDocumentService.removeDocument,
    downloadDocument: GatewayDocumentService.downloadDocument
};

function getRoutes() {
    const documentRoute = {
        path: '/documents',
        component: DocumentsPage
    };
    if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'document' })) {
        return [...pageRouting, documentRoute];
    }
    return pageRouting;
}

class QuoteDetails extends Component {
    static propTypes = {
        authHeader: PropTypes.shape({
            Authorization: PropTypes.string
        }).isRequired,
        match: PropTypes.shape({
            params: PropTypes.shape({
                jobNumber: PropTypes.string
            }),
            url: PropTypes.string
        }).isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string
        }).isRequired
    };

    state = {
        currentView: 'summary',
        tilesCountSubmissionData: {},
        quotes: {},
        isLoading: true
    };

    componentDidMount() {
        this.getQuoteSummaryCount();
        this.getJobByJobNumber();
        this.addRecentlyViewQuotes();
    }

    handleTilesOnClick = (id) => {
        this.setState({ currentView: id });
    };

    getQuoteSummaryCount = () => {
        const {
            authHeader,
            match: {
                params: { jobNumber }
            },
            location: { pathname }
        } = this.props;

        const routePath = pathname && (pathname.trim().split('/') || []);
        const selectedPageFromPath = routePath[routePath.length - 1];
        const activeTile = selectedPageFromPath || 'summary';

        SubmissionService.getSubmissionSummary(jobNumber, authHeader).then((response) => {
            this.setState({
                currentView: activeTile,
                tilesCountSubmissionData: response
            });
        });
    };

    updateQuoteSummary = (quotes) => {
        this.setState({ quotes });
    };

    getJobByJobNumber = async () => {
        const {
            authHeader,
            match: {
                params: { jobNumber }
            }
        } = this.props;

        const submission = await JobService.findJobByJobNumber(jobNumber, authHeader);
        this.updateQuoteSummary(submission);
    };

    addRecentlyViewQuotes = async () => {
        const {
            authHeader,
            match: {
                params: { jobNumber }
            }
        } = this.props;
        SubmissionService.addRecentlyViewedQuote(jobNumber, authHeader).then((response) => {
            this.setState({
                isLoading: false
            });
        });
    };

    render() {
        const { currentView, tilesCountSubmissionData, quotes, isLoading } = this.state;
        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }
        if (_.isEmpty(quotes)) {
            return null;
        }

        const overrides = {
            [currentView]: {
                active: true
            }
        };
        const quoteVM = { quotes, tilesCountSubmissionData };
        const resolvers = {
            resolveCallbackMap: {
                handleTilesOnClick: this.handleTilesOnClick
            },
            resolveComponentMap: {
                pageheadercomponent: PageHeaderComponent
            }
        };
        const QuoteDetailspage = (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={quoteVM}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
            />
        );

        const {
            match: {
                url,
                params: { jobNumber }
            }
        } = this.props;
        const quoteData = {
            jobNumber: jobNumber,
            loadQuoteSummary: quotes,
            updateJobSummary: this.updateQuoteSummary,
            getQuoteSummaryCount: this.getQuoteSummaryCount
        };
        return (
            <DependencyProvider value={{ DocumentPageService }}>
                {QuoteDetailspage}
                <CommonRoutes
                    steps={getRoutes()}
                    basePath={url}
                    setDocumentCount={this.getQuoteSummaryCount}
                    jobNumber={jobNumber}
                    quoteDetailsData={quoteData}
                />
            </DependencyProvider>
        );
    }
}

export default withAuthenticationContext(QuoteDetails);
